// ============================================================================
// FNE-BRIDGE Frontend - Palette de couleurs
// ============================================================================

export const palette = {
  // --- Couleurs principales ---
  primary: {
    main: '#1B5E20',
    light: '#4C8C4A',
    dark: '#003300',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FF6F00',
    light: '#FFA040',
    dark: '#C43E00',
    contrastText: '#FFFFFF',
  },

  // --- Couleurs de statut ---
  success: {
    main: '#2E7D32',
    light: '#60AD5E',
    dark: '#005005',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#D32F2F',
    light: '#EF5350',
    dark: '#C62828',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#ED6C02',
    light: '#FF9800',
    dark: '#E65100',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#0288D1',
    light: '#03A9F4',
    dark: '#01579B',
    contrastText: '#FFFFFF',
  },

  // --- Gris ---
  grey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },

  // --- Backgrounds ---
  background: {
    default: '#F5F7FA',
    paper: '#FFFFFF',
    sidebar: '#1B5E20',
    header: '#FFFFFF',
  },

  // --- Texte ---
  text: {
    primary: '#212121',
    secondary: '#757575',
    disabled: '#BDBDBD',
  },

  // --- Divider ---
  divider: '#E0E0E0',
} as const;

// --- Dark mode overrides ---
export const darkPalette = {
  primary: {
    main: '#4CAF50',
    light: '#81C784',
    dark: '#388E3C',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFB74D',
    light: '#FFE0B2',
    dark: '#FF9800',
    contrastText: '#000000',
  },
  background: {
    default: '#121212',
    paper: '#1E1E1E',
    sidebar: '#0D3B0E',
    header: '#1E1E1E',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#B0B0B0',
    disabled: '#666666',
  },
  divider: '#333333',
} as const;
